<nz-card [nzTitle]="'authentication.title'|translateTA"  [nzLoading]="loading">
<nz-form-item>
  <nz-form-label>{{'CODECOMPANY'|translateTA}}</nz-form-label>
  <nz-form-control>
    <search-input-new [searchProperties]="searchInputCodeCompany"   class="full-width" [(ngModel)]="codecompany" (onChangeData)="changingCompany($event)"></search-input-new>
  </nz-form-control>
</nz-form-item>

@if( codecompany!=null && codecompany.key!=0 ){
    <div class="filtros-rapidos">
    <nz-tag
      *ngFor="let f of filtros"
      nzMode="checkable"

      [(nzChecked)]="f.checked"
      (nzCheckedChange)="aplicarFiltros()"
    >
      {{ f.label }}
    </nz-tag>


    <input nz-input [disabled]="codecompany==null || codecompany.key==0" placeholder="{{'authentication.search'|translateTA}}" [(ngModel)]="searchMarketplace" (ngModelChange)="aplicarFiltros()"/>
  </div>

}

  <nz-list nzGrid [nzLoading]="loading"  [nzDataSource]="marketplacesFiltrados" >
    <nz-list-empty *nzNoResult [nzNoResult]="emptyTemplate"></nz-list-empty>
    <nz-row [nzGutter]="[16, 16]" class="cards-row">
      @for (m of marketplacesFiltrados; track m.codemktp) {
      <nz-col
        [nzXs]="24"
        [nzSm]="12"
        [nzMd]="8"
        [nzLg]="6"
        [nzXl]="6"
        class="card-col">
          <nz-card nzHoverable>
            <div class="market-card">
              <div class="card-header">
                <nz-avatar
                  nzShape="square"
                  nzSize="large"
                  [nzIcon]="'custom:' + m.icon"
                  class="market-avatar"
                  [style.background-color]=" m.bgColor||'#fff'"
                ></nz-avatar>
                <h3>{{ m.name }}</h3>
              </div>

              <ng-container *ngIf="m.waiting && !m.erro">
                <nz-tag nzColor="purple">
                    <nz-icon nzType="sync" nzSpin />
                  {{'authentication.waiting'|translateTA}}</nz-tag>
                <div class="button-container">
                  <button nz-button nzType="default" [nzLoading]="m.checkData" (click)="autenticarV2(m,false)">{{'authentication.renew'|translateTA}}</button>
                  <ng-container *ngIf="m.checkData">
                    <button nz-button  nzType="primary" nzDanger  (click)="cancelarAutenticacao(m)">{{'authentication.cancel'|translateTA}}</button>
                  </ng-container>              
                </div>
              </ng-container>
              <ng-container *ngIf="m.autenticado && !m.expirado && !m.erro && !m.waiting">
                <nz-tag nzColor="green">{{'authentication.authenticated'|translateTA}}</nz-tag>
                <div class="button-container">
                  <button nz-button nzType="default" [nzLoading]="m.checkData" (click)="autenticarV2(m,false)">{{'authentication.renew'|translateTA}}</button>
                  <ng-container *ngIf="m.checkData">
                    <button nz-button  nzType="primary" nzDanger (click)="cancelarAutenticacao(m)">{{'authentication.cancel'|translateTA}}</button>
                  </ng-container>
                </div>
                
              </ng-container>
              <ng-container *ngIf="(!m.autenticado || m.autenticado ==null) && !m.erro && !m.waiting">
                <nz-tag nzColor="blue">{{'authentication.notauthenticated'|translateTA}}</nz-tag>
                <div class="button-container">
                  <button nz-button nzType="primary" [nzLoading]="m.checkData" (click)="autenticarV2(m,true)">{{'authentication.authenticate'|translateTA}}</button>
                  <ng-container *ngIf="m.checkData">
                    <button nz-button  nzType="primary" nzDanger  (click)="cancelarAutenticacao(m)">{{'authentication.cancel'|translateTA}}</button>
                  </ng-container>
                </div>
              </ng-container>
              <ng-container *ngIf="m.autenticado && m.expirado">
                <nz-tag nzColor="yellow">{{'authentication.expired'|translateTA}}</nz-tag>
                <div class="button-container">
                  <button nz-button nzType="default" [nzLoading]="m.checkData" (click)="autenticarV2(m,false)">{{'authentication.renew'|translateTA}}</button>
                  <ng-container *ngIf="m.checkData">
                    <button nz-button  nzType="primary" nzDanger  (click)="cancelarAutenticacao(m)">{{'authentication.cancel'|translateTA}}</button>
                  </ng-container>              
                </div>
              </ng-container>           
              <ng-container *ngIf="m.erro">
                <nz-tag nzColor="red"> <nz-icon nzType="exclamation-circle" />  {{'authentication.error'|translateTA}}</nz-tag>
                <div class="button-container">
                  <button nz-button nzType="default" [nzLoading]="m.checkData" (click)="autenticarV2(m,false)">{{'authentication.renew'|translateTA}}</button>     
                </div>
              </ng-container>             
            </div>
          </nz-card>
        </nz-col>
      }
      </nz-row>
  </nz-list>
</nz-card>


<nz-modal
  [(nzVisible)]="modalVisivel"
  #modal
  nzTitle="{{'authentication.additionalfields'|translateTA }}"
  (nzOnCancel)="fecharModal()"
  [nzFooter]="modalFooter"
>
  <ng-container *nzModalContent>
      <form nz-form [formGroup]="additionalForm" [nzLayout]="'vertical'">
        @for ( field of modalAdditionalFields; track field.name ){
          @if( field.type== "switch"){
            <nz-form-item>
              <nz-form-label>{{field.label|translateTA}}</nz-form-label>
                <nz-form-control>
                    <nz-switch [formControlName]="field.name" [nzSize]="'default'"></nz-switch>
              </nz-form-control>
            </nz-form-item>
          }@else {
            <nz-form-item>
              <nz-form-label>{{field.label|translateTA}}</nz-form-label>
                <nz-form-control>
                    <input nz-input [type]="field.type" [formControlName]="field.name" [placeholder]="field.name|translateTA">
              </nz-form-control>
            </nz-form-item>
          }
          
        }
      </form>
  </ng-container>

  <ng-template #modalFooter>
    <button nz-button (click)="fecharModal()">{{'cancel'|translateTA}}</button>
    <button
      nz-button
      nzType="primary"
      (click)="autenticar()"
      [nzLoading]="selected?.checkData">
      {{'authentication.authenticate'|translateTA}}
    </button>

  </ng-template>
</nz-modal>

<ng-template #emptyTemplate >
           <nz-empty 
              nzNotFoundContent="{{'authentication.notfound'|translateTA}}"
              style="margin: 0">
            </nz-empty>
</ng-template>